// extracted by css-extract-rspack-plugin
export default {"root":"opz2Bb"};